import React from "react";
import { Modal, Box, Grid } from "@mui/material";
import { AiOutlineClose } from "react-icons/ai";

const RightSideModal = ({
  open,
  setOpen,
  modalContent,
  modalTitle,
  modalFooter,
  width,
  scroll,
}) => {
  const style = {
    position: "absolute",
    top: { md: "0%", sm: "10%", xs: "15%" },
    right: { md: "0%", sm: "10%", xs: "3%" },
    width: { md: width ? width : "50%", sm: "80%", xs: "94%" },
    bgcolor: "#fff",
    boxShadow: 24,
    borderRadius: "0.5em",
    outline: "none",
    border: "none",
  };

  // Style for the scrollable content container
  const scrollableContentStyle = {
    height:"85vh",
    overflowY: scroll ? "auto" : "hidden",
    zIndex:100
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Grid
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          lg={12}
          xs={12}
          md={12}
          style={{height:"5vh"}}
          className="rounded-top p-3 pb-0"
        >
          <Grid
            container
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            xs={12}
            className="py-2"
          >
            <Grid xs={11}>{modalTitle}</Grid>
            <Grid
              xs={1}
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"flex-end"}
            >
              <AiOutlineClose
                onClick={() => setOpen(false)}
                style={{ cursor: "pointer" }}
                size={20}
                color="#62676A"
              />
            </Grid>
          </Grid>


        </Grid>
        {/* Scrollable Content */}
        <Box sx={scrollableContentStyle} className="CustomScroll">
          {modalContent}
        </Box>

        {modalFooter && (
          <Grid
            container
            className="p-3 modal_box_shadow"
            justifyContent={"flex-end"}
          >
            {modalFooter}
          </Grid>
        )}
      </Box>
    </Modal>
  );
};

export default RightSideModal;
